import { createSlice, createAsyncThunk, createEntityAdapter } from '@reduxjs/toolkit';
import {
  updateExistentCampaign,
  getlistCampaigns,
  getSpecificCampaign,
  deleteSpecificCampaign,
  createNewCampaignAPI
} from '../../middlewares/API/Campaigns/campaign';
import { udpateApplicantCampaign } from 'src/middlewares/API/User/user';
import { useDispatch } from 'react-redux';

const campaignsAdapter = createEntityAdapter();

//THUNKS
export const listAllCampaigns = createAsyncThunk('campaigns/listCampaigns', async (id) => {
  const response = await getlistCampaigns(id);
  return response;
});

export const updateCampaign = createAsyncThunk('campaings/updateCampaign', async (input) => {
  const response = await updateExistentCampaign(input);
  return response;
});

export const specificCampaign = createAsyncThunk('campaigns/specificCampaign', async (id) => {
  const response = await getSpecificCampaign(id);
  return response;
});

export const deleteCampaign = createAsyncThunk('campaigns/deleteCampaign', async (input) => {
  const response = await deleteSpecificCampaign(input);
  return response;
});

const campaignSlice = createSlice({
  name: 'campaign',
  initialState: {
    currentCampaignId: null,
    id: '',
    currentUser: {},
    userGroup: '',
    isLoading: false,
    contractsSigned: false
  },
  reducers: {
    setLoadingState: (state, action) => {
      state.isLoading = action.payload;
    },
    setContractsSigned: (state, action) => {
      state.contractsSigned = action.payload;
    },
    setCurrentCampaignId: (state, action) => {
      state.currentCampaignId = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(createCampaignSlice.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(createCampaignSlice.fulfilled, (state, action) => {
      state.isLoading = false;
      state.currentCampaignId = action.payload.createCampaign.id;
      state.error = null;
      // state.currentUser = {
      //   ...state.currentUser,
      //   ...action.payload
      // };
    });
    builder.addCase(createCampaignSlice.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  }
});

//THUNK CREAR CAMPAÑA
export const createCampaignSlice = createAsyncThunk(
  'createCampaignSlice',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async (inputs, { dispatch, rejectWithValue }) => {
    try {
      const response = await createNewCampaignAPI(inputs);
      //dispatch(setCurrentCampaignId(response.data.createCampaign.id));
      return response;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
      return rejectWithValue(error.message || 'Unknown error');
    }
  }
);

//THUNK UPDATE APPLICANT
export const updateApplicantWeb = createAsyncThunk(
  'updateApplicantWeb',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async (inputs, { rejectWithValue }) => {
    try {
      const response = await udpateApplicantCampaign(inputs);
      return response;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
      return rejectWithValue(error.message || 'Unknown error');
    }
  }
);

export const { setLoadingState, setContractsSigned, setCurrentStep, setCurrentCampaignId } =
  campaignSlice.actions;

export default campaignSlice.reducer;

export const {
  selectAll: selectAllCampaigns,
  selectById: selectCampaignById,
  selectIds: selectCampaignIds
} = campaignsAdapter.getSelectors((state) => state.campaigns);

// export const selectContractsSigned = createDraftSafeSelector(
//   selectSelf,
//   (state) => state.campaign.isApproved
// );

//campaignsAdapter.getInitialState(),
